<template>
    <div>
        <AppNavbar />
        <PagesHero :breadcrumbData="{
            title: $t('terms.title'),
            subtitle: {
                first_text: $t('terms.label'),
                first_href: '/',
                second_text: $t('terms.title')
            }
        }" />
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h3 class="title">{{ $t('terms.head1') }}</h3>
                    <h4 class="subtitle">{{ $t("terms.p1_1") }}</h4>
                    <h4 class="subtitle">{{ $t("terms.p1_2") }}</h4>
                    <h4 class="subtitle">{{ $t("terms.p1_3") }}</h4>
                    <h3 class="title">{{ $t('terms.head2') }}</h3>
                    <h4 class="subtitle">{{ $t("terms.p2_1") }}</h4>
                    <h4 class="subtitle">{{ $t("terms.p2_2") }}</h4>
                    <h4 class="subtitle">{{ $t("terms.p2_3") }}</h4>
                    <h3 class="title">{{ $t('terms.head3') }}</h3>
                    <h4 class="subtitle">{{ $t("terms.p3_1") }}</h4>
                    <h4 class="subtitle">{{ $t("terms.p3_2") }}</h4>
                    <h4 class="subtitle">{{ $t("terms.p3_3") }}</h4>
                    <h3 class="title">{{ $t('terms.head4') }}</h3>
                    <h4 class="subtitle">{{ $t("terms.p4_1") }}</h4>
                    <h4 class="subtitle">{{ $t("terms.p4_2") }}</h4>
                    <h3 class="title">{{ $t('terms.head5') }}</h3>
                    <h4 class="subtitle">{{ $t("terms.p5_1") }}</h4>
                    <h4 class="subtitle">{{ $t("terms.p5_2") }}</h4>
                    <h4 class="subtitle">{{ $t("terms.p5_3") }}</h4>
                </div>
            </div>
        </div>

        <AppFooter />

    </div>
</template>

<script>
import AppFooter from '@/components/AppFooter.vue';
import AppNavbar from '@/components/AppNavbar.vue';
import PagesHero from '@/components/PagesHero.vue';


export default {
    components: {
        AppNavbar, PagesHero, AppFooter
    }
}

</script>

<style scoped>
.row {
    margin-top: 40px;
}

.title {
    font-size: 24px;
    font-weight: 500;
    color: #BF9F35;
    margin-top: 20px;
    margin-bottom: 20px;
}

.subtitle {
    font-size: 20px;
    font-weight: 400;
    color: #393735;
    margin-bottom: 10px;
}

.container {
    padding-bottom: 80px;
}
</style>